"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferPreview = void 0;
var _uiKit = require("@cian/ui-kit");
var _utils = require("@cian/utils");
var React = _interopRequireWildcard(require("react"));
var _utils2 = require("../../utils");
var styles = _interopRequireWildcard(require("./OfferPreview.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const OfferPreview = _ref => {
  let {
    area,
    floor,
    imageUrl,
    landArea,
    phone,
    price,
    link,
    onPhoneShow,
    onClick,
    name
  } = _ref;
  const [showPhone, setShowPhone] = React.useState(false);
  const handlePhoneShow = React.useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    setShowPhone(true);
    if (onPhoneShow) {
      onPhoneShow();
    }
  }, [onPhoneShow]);
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    className: styles['link'],
    onClick: onClick,
    rel: "noreferrer"
  }, imageUrl && /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${imageUrl})`
    },
    className: styles['image']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['info-container']
  }, name && /*#__PURE__*/React.createElement("div", {
    className: styles['info-row']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "gray60_100"
  }, name)), /*#__PURE__*/React.createElement("div", {
    className: styles['info-row']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading3, {
    fontWeight: "700"
  }, `${(0, _utils.numberToPrettyString)(price)} ₽`)), /*#__PURE__*/React.createElement("div", {
    className: styles['info-row']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, [floor, area, landArea].filter(Boolean).join(' • '))), /*#__PURE__*/React.createElement("div", {
    className: styles['phone-container']
  }, showPhone ? /*#__PURE__*/React.createElement("div", {
    className: styles['phone']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    fontWeight: "700"
  }, (0, _utils2.formatPhone)(phone))) : /*#__PURE__*/React.createElement(_uiKit.Button, {
    theme: "fill_secondary",
    fullWidth: true,
    size: "XS",
    onClick: handlePhoneShow
  }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D"))));
};
exports.OfferPreview = OfferPreview;